/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 22:10:31
 * @LastEditors: dee
 * @LastEditTime: 2022-04-21 11:35:21
 * @Description: 活动微信jssdk服务 
 * https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html
 */
import wx from "weixin-js-sdk";
import request from "@/http/common"
import apiActWxauth from "@/api/act-wxauth";

let shareTitle = '';
let shareDesc = '';
let shareLink = '';
let shareImgUrl = '';
let shareType = 'link';
let shareDataUrl = '';
let currentIsInMiniProgram = undefined;
/**
 * 设置分享
 * @param {string} title 分享标题
 * @param {string} desc 分享描述
 * @param {string} link 分享链接
 * @param {string} imgUrl 分享小图url
 */
function setShare(title, desc, link, imgUrl) {
  shareTitle = title || shareTitle;
  shareDesc = desc || shareDesc;
  shareLink = link || shareLink;
  shareImgUrl = imgUrl || shareImgUrl;
}
/**
 * 分享回调函数列表
 */
let shareCallBackFunList = {
  value: {},
  push: function () {
    if (arguments.length == 1) {
      this.value[new Date().getTime()] = arguments[0];
    } else if (arguments.length == 2) {
      this.value[arguments[0]] = arguments[1];
    }
  },
  remove: function (k) {
    delete this.value[k];
  },
  clear: function () {
    this.value = {};
  }
};
/**
 * 初始化
 * @param {object} options 初始化参数。appid，用来初始化wxjsdk的appid。
 */
function init(options) {
  console.log("@/services/act-wxjssdk.js options", options);
  let u = navigator.userAgent;
  // 仅在微信环境下获取签名
  if (u.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
    getSignature(options).then(jsParams => {
      wxConfig(jsParams, options);
    })
  }
}

// 封装的微信ready，如果是非微信环境立马执行
let ready = function (callback) {
  let u = navigator.userAgent;
  if (u.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
    wx.ready(callback);
  } else {
    callback();
  }
}

// 不导出
let shareCallBack = function () {
  Object.keys(shareCallBackFunList.value).forEach(k => {
    shareCallBackFunList.value[k]();
  });
};



// 不导出
function getSignature(options) {
  return new Promise((resolve, reject) => {
    let site = location.href.split("#/");
    if (site.length > 1) {
      site = site[0];
    } else {
      site = location.href;
    }
    let query = {
      htmlUrl: encodeURIComponent(site)
    }
    let realAppid = apiActWxauth.appid;
    if (options && options.appid) {
      realAppid = options.appid;
    }
    request.post(
      `${apiActWxauth.protocol}//${apiActWxauth.appid}.${apiActWxauth.domain}${apiActWxauth.action.getSignature}/${realAppid}/${apiActWxauth.openid}?${request.qs.stringify(query)}`,
      {}
    ).then((res) => {
      if (res && res.data && res.data.data) {
        resolve(res.data.data);
      } else {
        reject(res);
      }
    }).catch((res) => {
      reject(res);
    })
  })
}

// 不导出
function wxConfig(jsParams, options) {
  let realAppid = apiActWxauth.appid;
  if (options && options.appid) {
    realAppid = options.appid;
  }
  wx.config({
    debug: false,
    appId: realAppid,
    timestamp: jsParams.timestamp,
    nonceStr: jsParams.nonceStr,
    signature: jsParams.signature,
    jsApiList: [
      "checkJsApi",
      "updateAppMessageShareData",
      "updateTimelineShareData",
      "onMenuShareTimeline",
      "onMenuShareAppMessage",
      "onMenuShareQQ",
      "onMenuShareWeibo",
      "hideMenuItems",
      "showMenuItems",
      "hideAllNonBaseMenuItem",
      "showAllNonBaseMenuItem",
      "translateVoice",
      "startRecord",
      "stopRecord",
      "onRecordEnd",
      "playVoice",
      "pauseVoice",
      "stopVoice",
      "uploadVoice",
      "downloadVoice",
      "chooseImage",
      "previewImage",
      "uploadImage",
      "downloadImage",
      "getNetworkType",
      "openLocation",
      "getLocation",
      "hideOptionMenu",
      "showOptionMenu",
      "closeWindow",
      "scanQRCode",
      "chooseWXPay",
      "openProductSpecificView",
      "addCard",
      "chooseCard",
      "openCard"
    ],
    openTagList: ['wx-open-launch-weapp','wx-open-launch-app']
  });
  wx.ready(function () {
    wx.onMenuShareAppMessage({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      }
    });
    wx.onMenuShareTimeline({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      }
    });
  })
}

let util = {
  browser: {
    info: navigator.appVersion,
    versions: (function () {
      let u = navigator.userAgent;
      return {
        trident: u.indexOf("Trident") > -1,
        presto: u.indexOf("Presto") > -1,
        webKit: u.indexOf("AppleWebKit") > -1,
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
        iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1,
        iPad: u.indexOf("iPad") > -1,
        webApp: u.indexOf("Safari") == -1,
        wx: u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
      };
    })()
  }
}
function getIsInMiniProgram() {
  return new Promise(function (resolve) {
    if (currentIsInMiniProgram == undefined) {
      if (location.href.indexOf("ismp=1") > -1) {
        currentIsInMiniProgram = true;
        resolve(true);//模拟小程序
      }
      if (util.browser.versions.wx) {
        wx.miniProgram.getEnv(function (res) {
          currentIsInMiniProgram = res.miniprogram;
          resolve(res.miniprogram);
        });
      } else {
        currentIsInMiniProgram = false;
        resolve(false);
      }
    } else {
      resolve(currentIsInMiniProgram);
    }
  })
}

function getLocation() {
  return new Promise(function (resolve,reject) {
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        console.log(res)
        resolve(res)
      },cancel: function (res) {
        console.log(res)
        reject(res)
      }
    });
  })
}

function upShare(shareTitle,shareDesc,shareLink,shareImgUrl){
  
  wx.ready(function () {
    wx.onMenuShareAppMessage({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      }
    });
    wx.onMenuShareTimeline({
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      type: shareType,
      dataUrl: shareDataUrl,
      success: function () {
        shareCallBack();
      }
    });
  })
}
function startRecord() {
  wx.startRecord({
    success: function () {
      wx.stopRecord({
        success: function () {
          // var localId = res.localId;
        }
      });
    }
  });
}
function scanQRCode() {
  return new Promise(function (resolve,reject) {
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1 则直接返回扫描结果，
      scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: function(res) {
        console.log(res)
        resolve(res)
      },
      cancel: function (res) {
        console.log(res)
        reject(res)
      },
      error: function(res) {
        alert(res);
        reject(res)
      }
    })
  })
}
export default {
  sdk: wx,
  shareTitle,
  shareDesc,
  shareLink,
  shareImgUrl,
  shareType,
  shareDataUrl,
  shareCallBackFunList,
  init,
  setShare,
  ready,
  getIsInMiniProgram,
  getLocation,
  upShare,
  startRecord,
  scanQRCode,
}